let active = false;

/** While true, grid settings query should not be overwritten by refetch/subscription. */
export function isSeparatorDragActive() {
  return active;
}

export function setSeparatorDragActive(next: boolean) {
  active = next;
}
